import { createRoute, Outlet } from "@tanstack/react-router";
import { DocumentDetailsPage } from "pages/app/DocumentDetailsPage";
import { DocumentsPage } from "pages/app/DocumentsPage";

import { rootRoute } from "../rootRoute";

export const documentsLayoutRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/documents",
  staticData: { pageName: "", breadcrumbLabel: "Documents" },
  component: Outlet,
});

export const documentsIndexRoute = createRoute({
  getParentRoute: () => documentsLayoutRoute,
  path: "/",
  staticData: { pageName: "Documents" },
  component: DocumentsPage,
});

export const documentIdLayoutRoute = createRoute({
  getParentRoute: () => documentsLayoutRoute,
  path: "/$id",
  staticData: { pageName: "" },
  component: Outlet,
});

export const documentDetailRoute = createRoute({
  getParentRoute: () => documentIdLayoutRoute,
  path: "/",
  staticData: { pageName: "Document details" },
  component: function DocumentDetailRouteComp() {
    const { id } = documentDetailRoute.useParams();
    return <DocumentDetailsPage documentId={id} />;
  },
});

export const documentsRouteTree = documentsLayoutRoute.addChildren([
  documentsIndexRoute,
  documentIdLayoutRoute.addChildren([documentDetailRoute]),
]);
